export default __webpack_public_path__ + "static/media/nflStaff6.6694c537.jpg";